export default __webpack_public_path__ + "static/assets/2471a77526ec47adaaf1779a042a74be.svg";